// Import base components
import { httpV2 } from "../http.js";

const MessagesService = {
  sendMessage: (objMessage) => httpV2.post("messaging/outbound", objMessage),
  sendInternalNote: (objMessage) => httpV2.post("messaging/internal", objMessage),
};

export default MessagesService;
